<div class="collection-page-container container" *ngIf="collection; else loader" fxLayout="column"
     fxLayoutGap="30px">
  <div class="header-container" fxLayout="row" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <h1 class="mat-h1 color-accent no-bottom-margin">{{ collection.name }}</h1>
        <fa-icon class="clickable" [ngClass]="{'color-accent': collection.isFavoritedBy(currentUser.uuid)}"
                 [icon]="collection.isFavoritedBy(currentUser.uuid) ? 'star' : ['far', 'star']"
                 (click)="toggleFavorite()" matTooltip="{{ 'TOOLTIP_MESSAGES.FAVORITE' | translate }}"></fa-icon>
      </div>
      <div class="description-container">
        <small class="color-muted">{{ collection.description || ('COLLECTION_DETAILS.DESCRIPTION_PLACEHOLDER' | translate) }}</small>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="10px">
      <mtn-toolbar-button icon="share-alt" [disabled]="!collection.shares.length" (toolbarClick)="copyUrlToClipboard()"
                          [matTooltip]="collection.shares.length ? ('TOOLTIP_MESSAGES.COPY_LINK' | translate) : ('TOOLTIP_MESSAGES.COPY_LINK_DISABLED' | translate)"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                          [analyticsEventParameters]="{'target': 'collection-details-share-button'}"
                          [matTooltipClass]="collection.shares.length ? null : 'multiline-tooltip'"></mtn-toolbar-button>
      <mtn-toolbar-button icon="cloud-download-alt" [disabled]="!features.length" (toolbarClick)="openDownloadDialog()"
                          [matTooltip]="features.length ? ('TOOLTIP_MESSAGES.EXPORT' | translate) : ('TOOLTIP_MESSAGES.EXPORT_DISABLED' | translate)"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                          [analyticsEventParameters]="{'target': 'collection-details-export-button'}"
                          [matTooltipClass]="features.length ? null : 'multiline-tooltip'"></mtn-toolbar-button>
      <mtn-toolbar-button icon="clone" (toolbarClick)="openCloneCollectionWizard()"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                          [analyticsEventParameters]="{'target': 'collection-details-clone-button'}"
                          matTooltip="{{ 'TOOLTIP_MESSAGES.CLONE_COLLECTION' | translate }}"></mtn-toolbar-button>
      <mtn-toolbar-button icon="pencil-alt" [disabled]="!isCollectionEditor" (toolbarClick)="openEditCollectionWizard()"
                          [matTooltip]="isCollectionEditor ? ('TOOLTIP_MESSAGES.EDIT_COLLECTION' | translate) : ('TOOLTIP_MESSAGES.EDIT_COLLECTION_DISABLED' | translate)"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                          [analyticsEventParameters]="{'target': 'collection-details-edit-collection-button'}"
                          [matTooltipClass]="isCollectionEditor ? null : 'multiline-tooltip'"></mtn-toolbar-button>
      <mtn-toolbar-button icon="trash-alt" color="red" [disabled]="!isCollectionOwner"
                          (toolbarClick)="openConfirmDeleteCollectionWizard()"
                          [matTooltip]="isCollectionOwner ? ('TOOLTIP_MESSAGES.DELETE_COLLECTION' | translate) : ('TOOLTIP_MESSAGES.DELETE_COLLECTION_DISABLED' | translate)"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                          [analyticsEventParameters]="{'target': 'collection-details-delete-collection-button'}"
                          [matTooltipClass]="isCollectionOwner ? null : 'multiline-tooltip'"></mtn-toolbar-button>
    </div>
  </div>

  <div class="mid-section-container" fxLayout="row wrap" fxLayoutGap="30px">
    <div class="owner-container mat-elevation-z1 default-padding">
      <div class="panel-header-container" fxLayout="column">
        <strong>{{ 'COLLECTION_DETAILS.OWNER' | translate }}</strong>
        <hr/>
      </div>
      <mtn-user-card [userUuid]="collection.owner.uuid"></mtn-user-card>
    </div>

    <div class="shares-container mat-elevation-z1 default-padding" fxLayout="column" fxLayoutGap="15px">
      <div class="panel-header-container" fxLayout="column">
        <strong>{{ 'COLLECTION_DETAILS.SHARING_OPTIONS' | translate }}</strong>
        <hr/>
      </div>
      <div class="standard-share-container container" fxLayout="column">
        <mat-checkbox color="accent" [checked]="!!companyCollection" (change)="toggleShared()"
                      mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                      [analyticsEventParameters]="{'target': 'collection-details-is-viewable-button'}">
          <span>{{ 'SHARE_OPTIONS.VIEW_ACCESS' | translate }}</span>
        </mat-checkbox>
        <mat-checkbox color="accent" [checked]="companyCollection?.isEditable" [disabled]="!companyCollection"
                      mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                      [analyticsEventParameters]="{'target': 'collection-details-is-editable-button'}"
                      (change)="toggleEditable()">
          <span>{{ 'SHARE_OPTIONS.EDIT_ACCESS' | translate }}</span>
        </mat-checkbox>
        <mtn-spinner [on]="isSavingShares"></mtn-spinner>
      </div>
    </div>
  </div>

  <mtn-collection-feature-view [collection]="collection" [features]="features"
                               *ngIf="!isLoadingFeatures; else loader"></mtn-collection-feature-view>

</div>

<ng-template #loader>
  <div class="loader-container container">
    <mtn-spinner [size]="SpinnerSize.LARGE" [on]="true"></mtn-spinner>
    <p>{{ 'COLLECTION_DETAILS.LOADING_MESSAGE' | translate }}</p>
  </div>
</ng-template>
